import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ParkingTicketsChart = ({ data }) => {
  if (!data) return null;

  const chartOptions = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Parking Tickets Status",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b><br/>Count: <b>{point.y}</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Tickets",
        colorByPoint: true,
        data: [
          {
            name: "Active",
            y: data.active || 0,
            color: "#52c41a",
          },
          {
            name: "Pending",
            y: data.pending || 0,
            color: "#faad14",
          },
          {
            name: "Expired",
            y: data.expired || 0,
            color: "#ff4d4f",
          },
        ],
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default ParkingTicketsChart;
